import { render, staticRenderFns } from "./ModalMessageEdit.vue?vue&type=template&id=ae4da708&"
import script from "./ModalMessageEdit.vue?vue&type=script&lang=js&"
export * from "./ModalMessageEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModalMessageEdit.vue?vue&type=style&index=0&id=ae4da708&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports